import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  SideNavigation,
  SideNavigationItem,
} from '../../components/SideNavigation';

export const FindGroupMenu = React.memo(({ groupId }: { groupId: string }) => {
  const basePath = `/finds/groups/${groupId}`;

  return (
    <SideNavigation>
      <SideNavigationItem isDefault to={basePath}>
        <FormattedMessage
          id="finds.group.menu.settings"
          defaultMessage="Settings"
        />
      </SideNavigationItem>
      <SideNavigationItem to={`${basePath}/finds`}>
        <FormattedMessage id="finds.group.menu.finds" defaultMessage="Finds" />
      </SideNavigationItem>
      <SideNavigationItem to={`${basePath}/access`}>
        <FormattedMessage
          id="finds.group.menu.access"
          defaultMessage="Access"
        />
      </SideNavigationItem>
    </SideNavigation>
  );
});
